import React from 'react'

import UserStoryForm from 'app/domains/common/UserStoryForm'
import { ModalBody } from 'app/components/Modal'

import './styles.scss'
const bc = 'feed-stories-list-item-menu-popup'

const FeedStoriesListItemMenuPopup = ({
  onRequestClose,
  question,
  initialValues,
  customSubmit,
  extraBlock,
  ...props
}) => (
  <ModalBody onRequestClose={onRequestClose}>
    {extraBlock && React.createElement(extraBlock, { ...props })}
    <UserStoryForm
      question={question}
      className={bc}
      initialValues={initialValues}
      customSubmit={customSubmit}
      {...props}
    />
  </ModalBody>
)

export default FeedStoriesListItemMenuPopup
